import DashboardLayout from '../../../shared/DashboardLayout';

const EditHouseAgreement = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default EditHouseAgreement
